module.exports = __webpack_public_path__ + "img/2016-10-25.c950ef72.jpg";